import React, { useState } from 'react';
import styles from './DashboardPageAppMfg.module.css';
import previewUnavailableSmall from 'Assets/Icons/preview_unavailable_small.png';
import previewUnavailable from 'Assets/Icons/preview_unavailable.png';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { useSelector } from 'react-redux';
import { getAnalyticSummaryPageData } from 'Redux/DashboardVariables';
import { getLocationsData } from 'Redux/DashboardVariables';
import { getCameraData } from 'Redux/DashboardVariables';
import { Avatar, Chip, Paper, Tooltip } from '@mui/material';
import { getLocationName } from 'HelperFiles/DashboardHelper';
import { getCameraName } from 'HelperFiles/DashboardHelper';
import { generateDate } from 'HelperFiles/DateHelper';
import { generateTime } from 'HelperFiles/DateHelper';
import IconStatCard from 'CommonComponents/IconStatCard';
import DatagridPageDori from 'CommonComponents/DatagridPageDori';
import DoriVideoPlayer from 'CommonComponents/DoriVideoPlayer/DoriVideoPlayer';
import { iconColors } from 'HelperFiles/Constants';
import { getEventTypeColor } from 'HelperFiles/DashboardHelper';
import { getApplicationConfig } from 'Redux/DashboardVariables';

const AnalyticsListing = () => {
  const { eventReplyData: datagridData } = useSelector(getAnalyticSummaryPageData);
  const locationsData = useSelector(getLocationsData);
  const cameraData = useSelector(getCameraData);
  const applicationConfig = useSelector(getApplicationConfig);
  const countPerPage = 10;
  const [selectedStepIndex, setSelectedStepIndex] = useState(0);

  const tableColumns = [
    {
      headerName: "Preview",
      field: "preview",
      sortable: false,
      disableColumnMenu: true,
      minWidth: 150,
      headerClassName: 'datagrid-table--header',
      renderCell: (params) =>
        <div onClick={() => {
          setSelectedStepIndex(params.row.id);
        }}>
          <img src={params.row.thumbnail || previewUnavailableSmall} alt='Preview unavailable' height='auto' width='100px' />
        </div>

    },
    {
      headerName: 'Event Type',
      field: "incidentType",
      flex: 1.5,
      headerAlign: "left",
      align: "left",
      headerClassName: 'datagrid-table--header',
      sortable: true,
      renderCell: (params) =>
        <Tooltip title={params.row.incidentType}>
          <Chip
            style={{
              cursor: 'auto',
              color: 'white',
              backgroundColor: params.row.incidentType
                ? getEventTypeColor(params.row.incidentType, applicationConfig)
                : "gray"
            }}
            label={params.row.incidentType}
          />
        </Tooltip>
    },
    {
      headerName: 'Location',
      field: "locationId",
      flex: 1,
      headerAlign: "left",
      align: "left",
      headerClassName: 'datagrid-table--header',
      sortable: true,
      disableColumnMenu: true,
      minWidth: 200,
      renderCell: (params) =>
        <div style={{ height: '100%', padding: '10px 0', cursor: 'auto' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'left',
            alignItems: 'center',
            height: '50%'
          }}>
            {getLocationName(params.row.locationId, locationsData)}
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'left',
            alignItems: 'center',
            height: '50%'
          }}>
            {getCameraName(params.row.cameraId, cameraData)}
          </div>
        </div>
    },
    {
      headerName: 'Date / Time',
      field: "incidentTime",
      sortable: true,
      flex: 1.5,
      headerAlign: "left",
      align: "left",
      minWidth: 100,
      headerClassName: 'datagrid-table--header',
      defaultSort: "desc",
      renderCell: (params) =>
        <div style={{ height: '100%', padding: '10px 0', cursor: 'auto' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'left',
            alignItems: 'center',
            height: '50%'
          }}>
            {generateDate(params.row.incidentTime)}
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'left',
            alignItems: 'center',
            height: '50%'
          }}>
            {generateTime(params.row.incidentTime)}
          </div>
        </div>
    },
    //  {
    //    headerName: 'Actions',
    //    field: "actions",
    //    flex: 1,
    //    minWidth: 150,
    //    headerAlign: "center",
    //    align: "center",
    //    headerClassName: 'datagrid-table--header',
    //    renderCell: (params) => <div style={{ display: 'flex', minWidth: '120px', justifyContent: 'space-around' }}>
    //      <PlayCircleIcon style={{ color: '#17B696' }} />
    //      <LocalOfferIcon style={{ color: '#17B696' }} />
    //      <MailIcon style={{ color: '#17B696' }} />
    //    </div>
    //  },
  ];

  const cardStyle1 = { padding: "4px 8px", boxShadow: "none", height: "100%" };
  const cardStyle2 = { padding: "4px 8px", boxShadow: "none", height: "100%", textAlign: "left" };
  let displayAvatar = (bgcolor, icon) => {
    return (
      <Avatar sx={{ bgcolor: bgcolor }} aria-label="recipe">
        {icon}
      </Avatar>
    );
  }
  let useCases = [
    {
      title: "Event Type",
      body: datagridData.length !== 0 ?
        <div style={{ height: '100%', padding: '10px 0' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50%'
          }}>
            <Chip
              style={{
                color: 'white',
                fontWeight: 'bold',
                backgroundColor: datagridData[selectedStepIndex]
                  ? getEventTypeColor(datagridData[selectedStepIndex].incidentType, applicationConfig)
                  : "gray"
              }}
              label={datagridData[selectedStepIndex] ? datagridData[selectedStepIndex].incidentType : "---"}
            />
          </div>
        </div>
        :
        "---",
      bodyType: "div",
      bodyStyle: { fontWeight: 400, textAlign: "center" },
      footer: "",
      cardStyle: cardStyle1,
      avatar: displayAvatar(iconColors[0], <AnalyticsIcon />),
    },
    {
      title: "Location",
      body: datagridData.length !== 0 ?
        <div style={{ height: '100%', padding: '10px 0' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50%'
          }}>
            {datagridData[selectedStepIndex]
              ? getLocationName(datagridData[selectedStepIndex].locationId, locationsData)
              : '---'}
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50%'
          }}>
            {datagridData[selectedStepIndex]
              ? getCameraName(datagridData[selectedStepIndex].cameraId, cameraData)
              : '---'}
          </div>
        </div>
        :
        "---",
      bodyType: "div",
      bodyStyle: { textAlign: "center", fontSize: "1rem", fontWeight: 400, color: "#9e9e9e" },
      footer: "",
      cardStyle: cardStyle1,
      avatar: displayAvatar(iconColors[1], <LocationOnIcon />),
    },
    {
      title: "Date / Time",
      body: datagridData.length !== 0 ?
        <div style={{ height: '100%', padding: '10px 0' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50%'
          }}>
            {datagridData[selectedStepIndex]
              ? generateDate(datagridData[selectedStepIndex].incidentTime)
              : '---'}
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50%'
          }}>
            {datagridData[selectedStepIndex]
              ? generateTime(datagridData[selectedStepIndex].incidentTime)
              : '---'}
          </div>
        </div>
        :
        "---",
      bodyType: "div",
      bodyStyle: { textAlign: "center", fontSize: "1rem", fontWeight: 400, color: "#9e9e9e" },
      footer: "",
      cardStyle: cardStyle1,
      avatar: displayAvatar(iconColors[2], <AccessTimeFilledIcon />),
    },
  ]

  const displayCard = (useCase) => {
    return (
      <Paper
        key={useCase.title}
        elevation={0}
        style={{
          padding: '1px 1px',
          background: "transparent",
          width: "33vw",
        }}
      >
        <IconStatCard
          title={useCase.title}
          subheader={useCase.subheader}
          body={useCase.body}
          bodyStyle={useCase.bodyStyle}
          bodyType={useCase.bodyType}
          footer={useCase.footer}
          cardStyle={useCase.cardStyle}
          avatar={useCase.avatar}
          footerButtonOnClick={useCase.footerButtonOnClick}
        />
      </Paper>
    );
  }
  let useCasesDisplay = useCases.map(useCase => displayCard(useCase));

  const onClickPrevious = () => {
    if (selectedStepIndex !== 0) {
      setSelectedStepIndex(selectedStepIndex - 1);
    }
  }

  const onClickNext = () => {
    if (selectedStepIndex < datagridData.length - 1) {
      setSelectedStepIndex(selectedStepIndex + 1)
    }
  }

  // console.log('datagrid data: ', datagridData);

  return (
    <>
      <div className={styles.topContainer}>
        <div className={styles.leftColumnContainer}>
          <div style={{ height: '100%', overflow: 'scroll', background: "white" }}>
            <DatagridPageDori
              rowHeight={75}
              columns={tableColumns}
              rows={datagridData}
              disableColumnMenu={false}
              countPerPage={countPerPage}
              checkboxSelection={false}
              switchRowBackgroundColor
              selectedRowNumber={selectedStepIndex}
              disableSelectionOnClick
            />
          </div>
        </div>
        <div className={styles.rightColumnContainer}>
          <div style={{ display: 'flex' }}>
            <div className={styles.topContainerDashboard} style={{ margin: "0px 0px 0px 0px" }}>
              {useCasesDisplay}
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <DoriVideoPlayer
              disablePrev={selectedStepIndex === 0}
              disableNext={selectedStepIndex === datagridData.length - 1 || datagridData.length === 0}
              onClickNext={onClickNext}
              onClickPrevious={onClickPrevious}
              videoUrl={datagridData.length !== 0 && datagridData[selectedStepIndex]
                ? datagridData[selectedStepIndex].video
                : ''}
              thumbnail={
                datagridData.length !== 0 && datagridData[selectedStepIndex]
                  ? datagridData[selectedStepIndex].thumbnail
                  : previewUnavailable}
            />
          </div>
        </div>
      </div>
    </>
  );
};


export default AnalyticsListing;
